var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 748.7 578.1",
    enableBackground: "new 0 0 748.7 578.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M178,0.2c-64,0-101.9,0.3-113.9,0.9C51.8,1.6,42.9,3.5,37.5,6.7C23.8,13.9,13.3,24.5,5.9,38.5 c-11.2,64.8-2.7,92.6-5.4,234.2C4.3,409.1-9.8,501,16.7,521.8c5.7,6.9,25,16.5,33.5,18.5c4.9,1.3,53.4,2.3,145.7,2.8 c92.2,0.6,144.9-0.2,158.2-2.3c16.9-3.6,19.7-5.7,19.9-22.4c-0.1-16.5-3-19-19.6-22.4c-13.1-2.1-54.8-3.1-125.2-3.1 c-70.2,0-115.3,0.1-135.4,0.3c-20.1,0.2-32.1-1.1-36.1-4c-4-2.8-6.2-13.1-6.8-30.7c-1.3-19.4-1-265.8,0-278 c0.6-13.8,2.4-21.8,5.4-23.9c43.1-8.9,564.2-4.3,564.8-0.6c10.9,5.7,6,18.9,7.7,42.6c0.6,19.3,2,30.6,4.3,33.8 c1.9,6.5,43.1,6.5,44.6-0.6c4.2-4.2,3.4-71.7,2-76.9c-7.4-28.4-27.4-50.7-60.5-51.7c-20.9-5-216-1.2-244-7.2 c-12.8-2.7-18.7-51.6-22.9-57C317.9-17.1,280,5.5,178,0.2 M312.3,77.7c5.1,14.2,7.3,21.7,6.5,22.4c12.4,1.1-279.7,2.4-267.5,1.1 c-1.3,1.1-1.5-38.4-0.3-39.5c9.9-18,51.9-9.1,125.5-11.9c75.9,0,116.4,1,121.5,3.1C302.7,55.3,307.4,63.5,312.3,77.7  M612.4,305.2c-33.4,4.5-23.6,24.6-25.6,62.5c-2,51.1,1.1,46.1-50,49.1c-38.7,2.9-60.7-7.8-60.2,27.8 c3.5,30.6,30.9,20.5,62.8,22.7c23.7,0,37.5,2,41.5,6c8.9,5.5,4.7,81.9,8,88.3c3.4,19.3,30.8,20.8,42,9.4 c14.7-9,0.5-85.2,13.3-97.1c11.1-12.5,90.6-0.6,99.1-14.5c7.6-9,7.2-28.2-1.7-36.1c-13.5-11.3-23.3-5.4-55.4-7.1 c-24,0-38.1-2-42.3-6c-8.2-2.8-5.3-81.1-6.8-85.2C635.6,313.1,624.7,305,612.4,305.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolderIcon);
export default __webpack_public_path__ + "static/media/add_folder_icon.edfa86e9.svg";
export { ForwardRef as ReactComponent };